<ng-container [formGroup]="form">

  <app-base-field-html [form]="form" [fieldData]="fieldData" [editMode]="editMode" [readonly]="readonly"
                       [hideField]="hideField" [scrollContainer]="scrollContainer" [inputId]="inputId"
                       (emitPush)="push()">

    <div [ngClass]="{'uk-disabled': readonly}">
      @if (fieldData.typeInfo.multiplicity) {

      } @else {
        <textarea class="uk-textarea uk-width-9-10 uk-animation-scale-up"
                  [class.uk-form-danger]="checkFormValidity()"
                  [formControlName]="fieldData.name" [id]="inputId"
                  [placeholder]="fieldData.form.placeholder ?? ''" [maxlength]=maxLength
                  (input)="updateBitSet(fieldData); unsavedChangesPrompt()"
                  (focusin)="focus()" (focusout)="focusOut(false)">
        </textarea>
        <div class="uk-width-9-10">
          @if (maxLength) {
            <div class="uk-animation-scale-up uk-flex uk-flex-right">
              <span> {{ form.get(fieldData.name).value ? form.get(fieldData.name).value.length : 0 }}</span>
              <span>/ {{ maxLength }}</span>
            </div>
          }
        </div>
      }
    </div>

  </app-base-field-html>

</ng-container>
